(function (module) {
    'use strict';

    function AddIntegrationCtrl(_, Popup, $scope, $state, envService, IntegrationTemplate, Store, Integration, Includes) {
        this.$onInit = () => {
            IntegrationTemplate
                .find()
                .$promise
                .then((integrationTemplates) => {
                    // Alpha-gated typed integrations (achievers, workday) are
                    // offered only to accounts on the alpha programme (see
                    // filter-integration-templates.js). API-side enforcement
                    // lands later; until then the Manager hides them for
                    // accounts without `account.alpha`.
                    this.integrationTemplates = filterIntegrationTemplates(
                        integrationTemplates,
                        Store.getCurrentAccount()
                    );
                });
        };

        this.connect = () => {
            const template = this.integrationTemplate;

            // Typed providers continue in the full-page form. OAuth providers
            // keep the existing provider popup flow.
            if (template && template.strategy === 'typed') {
                this.typedIntegrationTemplate = template;
                return;
            }

            // --- Existing OAuth popup flow (UNCHANGED) ---
            const UI_URI = envService.read('UI_URI');
            const config = {
                url: `${UI_URI}/social/${template.provider}/${template.id}`,
                redirectUri: `${UI_URI}/social/${template.provider}/callback`,
                popupOptions: {
                    width: 900,
                    height: 600,
                },
            };

            Popup
                .open(config)
                .then(({ id }) => {
                    return Integration.findById({ id, filter: Includes.integrations }).$promise;
                })
                .then((integration) => {
                    return Store.setSingleModelData('integrations', integration.id, integration);
                })
                .then((integration) => {
                    $state.go('root.integrations.edit-integration', { id: integration.id });
                });
        };

        this.typedCredentialsConnected = (integration) => {
            Store.setSingleModelData('integrations', integration.id, integration);
            $state.go('root.integrations.edit-integration', { id: integration.id });
        };

        this.cancelTypedCredentials = () => {
            this.typedIntegrationTemplate = null;
        };

    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider) => {
            $stateProvider
                .state('root.integrations.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'PLAYERS_ADD.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<integration-add-component/>',
                        },
                    },

                });

            $translatePartialLoaderProvider.addPart('/js/integrations');

        })
        .component('integrationAddComponent', {
            templateUrl: '/js/integrations/add-integration/add-integration.html',
            controller: AddIntegrationCtrl,
        });

})(angular.module('rocket.components'));
